import { createContext, useContext, useState, type ReactNode } from "react";

interface SplashContextValue {
  splashComplete: boolean;
  setSplashComplete: (v: boolean) => void;
}

const SplashContext = createContext<SplashContextValue>({
  splashComplete: false,
  setSplashComplete: () => {},
});

export function SplashProvider({ children }: { children: ReactNode }) {
  const [splashComplete, setSplashComplete] = useState(false);
  return (
    <SplashContext.Provider value={{ splashComplete, setSplashComplete }}>
      {children}
    </SplashContext.Provider>
  );
}

export function useSplashComplete() {
  return useContext(SplashContext);
}